import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionFinanceApi = {
    getInstitutionFinanceByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionFinanceByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionFinanceByInstitutionId = new Dtos.GetInstitutionFinanceByInstitutionId();
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionFinanceByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionFinanceById: (id: number): Observable<Dtos.GetInstitutionFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionFinanceById = new Dtos.GetInstitutionFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionFinance: (institutionFinance: Dtos.InstitutionFinance): Observable<Dtos.SetInstitutionFinanceResponse> => {

        let request: Dtos.SetInstitutionFinance = new Dtos.SetInstitutionFinance();

        request.institutionFinance = institutionFinance;

        // send request
        const response: Promise<Dtos.SetInstitutionFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createInstitutionFinance: (institutionId: number): Observable<Dtos.CreateInstitutionFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionFinance = new Dtos.CreateInstitutionFinance();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionFinance: (institutionFinance: Dtos.InstitutionFinance): Observable<Dtos.ValidateInstitutionFinanceResponse> => {

        let request: Dtos.ValidateInstitutionFinance = new Dtos.ValidateInstitutionFinance();

        request.institutionFinance = institutionFinance;

        // send request
        const response: Promise<Dtos.ValidateInstitutionFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}